export const FETCH_PINNED_VIEWS_SUCCEEDED = 'FETCH_PINNED_VIEWS_SUCCEEDED';